/* ═══════════════════════════════════════════════════════════════
   REVERIE COLLECTIF — Brand JS
   ───────────────────────────────────────────────────────────────
   - Scroll detection per header (trasparente → solid Nuit)
   - Mobile menu toggle
   - PDP image gallery switcher
   - PDP accordion details
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ─── NAV: scroll detection ─────────────────────────────────
  const nav = document.querySelector('.rv-nav');
  if (nav) {
    const updateScrolled = () => {
      if (window.scrollY > 80) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    };
    updateScrolled();
    window.addEventListener('scroll', updateScrolled, { passive: true });
  }

  // ─── MOBILE MENU toggle ────────────────────────────────────
  const burger = document.querySelector('.rv-nav__burger');
  const mobileMenu = document.querySelector('.rv-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-active', isOpen);
      nav.classList.toggle('is-menu-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Chiudi menu quando clicco un link
    mobileMenu.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        burger.classList.remove('is-active');
        nav.classList.remove('is-menu-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ─── PDP: gallery switcher ─────────────────────────────────
  const pdpGalleryMain = document.querySelector('[data-rv-pdp-main]');
  const pdpThumbs = document.querySelectorAll('[data-rv-pdp-thumb]');
  if (pdpGalleryMain && pdpThumbs.length) {
    pdpThumbs.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const src = thumb.dataset.rvPdpThumb;
        const alt = thumb.dataset.rvPdpAlt || '';
        const idx = thumb.dataset.rvPdpIndex || '';
        const img = pdpGalleryMain.querySelector('img');
        if (img && src) {
          img.src = src;
          img.alt = alt;
        }
        const counter = pdpGalleryMain.querySelector('[data-rv-pdp-counter]');
        const total = pdpThumbs.length;
        if (counter && idx) {
          counter.textContent = String(parseInt(idx, 10) + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
        }
        pdpThumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // ─── PDP: accordion details ────────────────────────────────
  document.querySelectorAll('[data-rv-accordion-toggle]').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const content = toggle.nextElementSibling;
      const isOpen = toggle.classList.toggle('is-open');
      if (content) {
        content.style.display = isOpen ? 'block' : 'none';
      }
    });
  });

  // ─── PDP: size selector + variant id update ────────────────
  function rvUpdateSelectedVariant(form) {
    if (!form) return;
    const variantsScript = form.querySelector('[data-rv-variants]');
    if (!variantsScript) return;
    let variants;
    try { variants = JSON.parse(variantsScript.textContent); }
    catch(e) { return; }

    // Raccogli le opzioni selezionate dal form
    const selectedOptions = {};
    form.querySelectorAll('[data-rv-size-group]').forEach(group => {
      const hidden = group.querySelector('[data-rv-size-hidden]');
      if (hidden && hidden.name) {
        const match = hidden.name.match(/options\[(.+)\]/);
        if (match) selectedOptions[match[1]] = hidden.value;
      }
    });

    // Cerca la variante corrispondente (Shopify ordina come option1, option2, option3)
    const optionKeys = Object.keys(selectedOptions);
    const matched = variants.find(v => {
      return (
        (!optionKeys[0] || v.option1 === selectedOptions[optionKeys[0]]) &&
        (!optionKeys[1] || v.option2 === selectedOptions[optionKeys[1]]) &&
        (!optionKeys[2] || v.option3 === selectedOptions[optionKeys[2]])
      );
    });

    // Aggiorna il campo hidden id + il bottone ATC
    const idInput = form.querySelector('[data-rv-selected-variant-id]');
    const atcBtn = form.querySelector('[name="add"]');
    if (matched && idInput) {
      idInput.value = matched.id;
      if (atcBtn) {
        if (matched.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.dataset.rvAtcText || 'Aggiungi al carrello';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = atcBtn.dataset.rvSoldoutText || 'Esaurito';
        }
      }
    }
  }

  document.querySelectorAll('[data-rv-size-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-rv-size-group]');
      if (!group) return;
      group.querySelectorAll('[data-rv-size-btn]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const size = btn.dataset.rvSizeBtn;
      const hidden = group.querySelector('[data-rv-size-hidden]');
      if (hidden) hidden.value = size;
      // Ora aggiorna il variant id del form
      const form = btn.closest('form');
      rvUpdateSelectedVariant(form);
    });
  });
// ─── CART DRAWER: apri/chiudi ──────────────────────────────
  const cartDrawer = document.getElementById('rv-cart-drawer');
  const cartDrawerBody = document.getElementById('rv-cart-drawer-body');

  function rvOpenCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function rvCloseCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Intercetta TUTTI i link al carrello e apri drawer invece
  document.addEventListener('click', function(e) {
    const cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (cartLink && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      rvOpenCartDrawer();
    }
    // Chiudi con backdrop/X
    if (e.target.closest('[data-rv-cart-close]')) {
      rvCloseCartDrawer();
    }
  });

  // ESC chiude
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      rvCloseCartDrawer();
    }
  });

  // ─── CART: aggiorna quantità via AJAX ──────────────────────
  async function rvFetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    return await res.json();
  }

  async function rvUpdateCartLine(line, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    });
    return await res.json();
  }

  async function rvRefreshCartDrawer() {
    if (!cartDrawerBody) return;
    const res = await fetch(window.location.pathname + '?section_id=rv-cart-drawer', {
      headers: { 'Accept': 'text/html' }
    });
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newBody = doc.getElementById('rv-cart-drawer-body');
    if (newBody) cartDrawerBody.innerHTML = newBody.innerHTML;
    // Aggiorna counter in nav
    const cart = await rvFetchCart();
    // Aggiorna counter nav desktop (link "Cart (X)")
document.querySelectorAll('.rv-nav__link').forEach(el => {
  if (el.textContent.trim().toLowerCase().startsWith('cart')) {
    el.textContent = 'Cart (' + cart.item_count + ')';
  }
});
// Aggiorna counter nav mobile (icona)
document.querySelectorAll('.rv-nav__cart-count').forEach(el => {
  el.textContent = cart.item_count;
});
  }

// Intercetta click su quantity + remove (optimistic UI)
  let rvCartDebounce;
  document.addEventListener('click', async function(e) {
    const qtyBtn = e.target.closest('[data-rv-qty-change]');
    if (!qtyBtn) return;
    e.preventDefault();
    const line = qtyBtn.dataset.rvQtyChange;
    const currentItem = qtyBtn.closest('[data-rv-cart-item]');
    const qtyEl = currentItem ? currentItem.querySelector('.rv-cart-content__qty-value') : null;

    let newQty;
    if (qtyBtn.dataset.rvQtySet !== undefined) {
      newQty = parseInt(qtyBtn.dataset.rvQtySet, 10);
    } else {
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      const delta = parseInt(qtyBtn.dataset.rvQtyDelta, 10);
      newQty = Math.max(0, current + delta);
    }

    // 1. Aggiorna subito l'UI (optimistic)
    if (qtyEl) qtyEl.textContent = newQty;
    if (newQty === 0 && currentItem) {
      currentItem.style.opacity = '0.3';
      currentItem.style.pointerEvents = 'none';
    }

    // 2. Chiama server e refresha in background (debounced)
    clearTimeout(rvCartDebounce);
    rvCartDebounce = setTimeout(async () => {
      try {
        await rvUpdateCartLine(line, newQty);
        await rvRefreshCartDrawer();
      } catch (err) {
        console.error('[rv-cart]', err);
        await rvRefreshCartDrawer(); // ripristina stato reale in caso di errore
      }
    }, 250);
  });

  // ─── NOTIFICA SILENZIOSA ATC ───────────────────────────────
  let rvToast;
  function rvShowAtcToast(productTitle) {
    if (rvToast) rvToast.remove();
    rvToast = document.createElement('div');
    rvToast.className = 'rv-toast';
    rvToast.innerHTML = `
      <div class="rv-toast__body">
        <span class="rv-toast__label"><em>Aggiunto</em></span>
        <span class="rv-toast__title">${productTitle}</span>
        <a href="/cart" class="rv-toast__link" data-rv-toast-view>vedi carrello →</a>
      </div>
    `;
    document.body.appendChild(rvToast);
    requestAnimationFrame(() => rvToast.classList.add('is-visible'));
    setTimeout(() => {
      if (rvToast) {
        rvToast.classList.remove('is-visible');
        setTimeout(() => { if (rvToast) { rvToast.remove(); rvToast = null; }}, 400);
      }
    }, 3500);
  }

  // Intercetta submit di QUALSIASI form ATC
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    const isAtc = action.includes('/cart/add') || form.dataset.rvAtcForm === 'true' || form.classList.contains('rv-pdp__form');
    if (!isAtc) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[name="add"]');
    if (submitBtn) submitBtn.disabled = true;
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      const data = await res.json();
      if (res.ok) {
        rvShowAtcToast(data.product_title || 'Prodotto');
        await rvRefreshCartDrawer();
      } else {
        alert(data.description || 'Errore aggiunta al carrello');
      }
    } catch (err) {
      console.error('[rv-atc]', err);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
// ─── HOMEPAGE CARDS: gallery manuale (frecce + dots + swipe) ──
  document.querySelectorAll('[data-rv-card]').forEach(card => {
    const slides = card.querySelectorAll('[data-rv-slide-idx]');
    const dots = card.querySelectorAll('[data-rv-dot-idx]');
    const arrows = card.querySelectorAll('[data-rv-arrow]');
    if (slides.length <= 1) return;

    let current = 0;

    function showSlide(idx) {
      current = ((idx % slides.length) + slides.length) % slides.length;
      slides.forEach(s => s.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));
      if (slides[current]) slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    // Frecce
    arrows.forEach(arrow => {
      arrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const dir = arrow.dataset.rvArrow;
        showSlide(dir === 'next' ? current + 1 : current - 1);
      });
    });

    // Dots
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showSlide(idx);
      });
    });

    // Swipe mobile
    let touchStartX = 0;
    const imgContainer = card.querySelector('.rv-drop__card-img');
    if (imgContainer) {
      imgContainer.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      imgContainer.addEventListener('touchend', e => {
        const diff = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(diff) < 40) return;
        if (diff < 0) showSlide(current + 1);
        else showSlide(current - 1);
      }, { passive: true });
    }
  });

  // ─── HOMEPAGE: quick-add taglia ────────────────────────────
  document.querySelectorAll('[data-rv-quick-variant]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      const variantId = btn.dataset.rvQuickVariant;
      const productTitle = btn.dataset.rvProductTitle;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const data = await res.json();
        if (res.ok) {
          rvShowAtcToast(productTitle || data.product_title || 'Prodotto');
          if (typeof rvRefreshCartDrawer === 'function') {
            await rvRefreshCartDrawer();
          }
          btn.textContent = '✓';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1200);
        } else {
          btn.textContent = originalText;
          btn.disabled = false;
          alert(data.description || 'Errore');
        }
      } catch (err) {
        console.error('[rv-quickadd]', err);
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });
  // ─── SIZE GUIDE MODAL ──────────────────────────────────────
  const sgModal = document.getElementById('rv-size-guide');

  function rvOpenSizeGuide() {
    if (!sgModal) return;
    sgModal.classList.add('is-open');
    sgModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function rvCloseSizeGuide() {
    if (!sgModal) return;
    sgModal.classList.remove('is-open');
    sgModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-rv-sg-open]')) {
      e.preventDefault();
      rvOpenSizeGuide();
    }
    if (e.target.closest('[data-rv-sg-close]')) {
      rvCloseSizeGuide();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sgModal && sgModal.classList.contains('is-open')) {
      rvCloseSizeGuide();
    }
  });
})();
